export abstract class AppStatusState {
  private static readonly storageKey: string = "hasTriggeredAppReady";

  public static get(): string | undefined {
    return sessionStorage.getItem(AppStatusState.storageKey) ?? undefined;
  }

  public static set(value: string) {
    sessionStorage.setItem(AppStatusState.storageKey, value);
  }

  public static clear() {
    sessionStorage.removeItem(AppStatusState.storageKey);
  }
}
